// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const HotWater = ({ fill, svgComponents: { G, Path, Rect } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M15.38,12.73a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,15.38,12.73Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,15.38,7.45Z" />
            <Path d="M29.23,12.73a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,29.23,12.73Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,29.23,7.45Z" />
            <Path d="M25.45,9.92h-1a2.14,2.14,0,0,0-4.28,0h-1a3.14,3.14,0,0,1,6.28,0Z" />
            <Rect height="1" width="8.57" x="18.02" y="9.09" />
            <Rect height="3.96" width="1" x="21.81" y="9.59" />
            <Path d="M22.31,26.58a6.79,6.79,0,0,1-6.22-4.12H9.29v3.79H4v-5c0-2.43,2.38-4.13,5.78-4.13h6.31a6.76,6.76,0,0,1,12.44,0H36v5.29H28.53A6.79,6.79,0,0,1,22.31,26.58Zm-14-5.12h8.49l.12.33a5.76,5.76,0,0,0,10.82,0l.12-.33H35V18.17H27.84l-.12-.33a5.76,5.76,0,0,0-10.82,0l-.12.33h-7C7,18.17,5,19.46,5,21.3v4H8.29Z" />
            <Path d="M6.48,33.55a2,2,0,0,1-2-2A7.67,7.67,0,0,1,5.79,28a.85.85,0,0,1,1.38,0,7.69,7.69,0,0,1,1.29,3.59A2,2,0,0,1,6.48,33.55Zm0-4.78a6.54,6.54,0,0,0-1,2.81,1,1,0,0,0,2,0A6.57,6.57,0,0,0,6.48,28.76Zm-.15-.24h0Zm.3,0h0Z" />
            <Path d="M26.39,18.45a.5.5,0,0,1-.48-.35,3.38,3.38,0,0,0-3-2.37.5.5,0,0,1-.47-.53.49.49,0,0,1,.52-.47,4.38,4.38,0,0,1,3.95,3.07.5.5,0,0,1-.33.63Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default HotWater;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/hot-water/index.js